<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}



  section.u-mt-md.u-mb-md
    AppLink(to="/careers/opportunities" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat teams",
    "pageDesc":"Join our teams in the fields of design, business, development and technology.",
    "mantra":"Small teams. |Bigger impact",
    "sec1Items":{
      "1":{
        "title":"Business",
        "desc":"Working across all the aspects of strategy to validate business ideas, innovate business models and create plans that are industry specific.",
        "url":"/teams/business"
      },
      "2":{
        "title":"Branding",
        "desc":"We create brands that connect emotionally with the target audience by using the power of the visuals and strategy.",
        "url":"/teams/branding"
      },
      "3":{
        "title":"Advertising",
        "desc":"Creating campaigns using 3D, 2D and other techniques that start from a solid strategy and deep audience understanding.",
        "url":"/teams/advertising"
      },
      "4":{
        "title":"Product design",
        "desc":"Engineering the product specifications starting from the modelling phase until the material and prototype execution. ",
        "url":"/teams/product-design"
      },
      "5":{
        "title":"Type design",
        "desc":"Studying variety of fonts in different languages to come up with unique custom fonts that are both readbile and stylish.",
        "url":"/teams/type-design"
      },
      "6":{
        "title":"Interaction",
        "desc":"Creating clean interfaces and design systems by following a visual strategy and aligning efforts with both business and branding teams.",
        "url":"/teams/interaction"
      },
      "7":{
        "title":"Development",
        "desc":"Playing with code to create websites, software and mobile apps using cutting edge technology. Development team works aligned with design and business to innovate features that support the overall idea.",
        "url":"/teams/development"
      },
      "8":{
        "title":"Technology",
        "desc":"Capitalizing on the powers of hardware, software and design to create solutions that are powered by the business needs and customers' requirements.",
        "url":"/teams/technology"
      }
    },

    "cta":"See open <br> opportunities"
  },
  "ar": {
    "pageTitle":"الفرق",
    "pageDesc":"انضم إلى فريق بيانات واختار المجال الذي تفضله سواء الأعمال التجارية أو التصميم أو البرمجة أو التكنولوجيا.",
    "mantra":"فرق صغيرة ذات |تأثير كبير. ",
    "sec1Items":{
      "1":{
        "title":"الأعمال التجارية",
        "desc":"يمكنك العمل عبر جميع جوانب الاستراتيجية من أجل التحقق من صحة أفكارك وابتكار نماذج أعمالك ووضع الخطط المناسبة لكل صناعة. ",
        "url":"/teams/business"
      },
      "2":{
        "title":"العلامة التجارية",
        "desc":"نخلق العلامات التجارية التي تتصل عاطفيًا مع الجمهور المستهدف اعتمادًا على الاستراتيجية وقوى الصور البصرية.",
        "url":"/teams/branding"
      },
      "3":{
        "title":"الحملات الإعلانية",
        "desc":"نخلق حملات إعلانية باستخدام تقنيات ثنائية وثلاثية الأبعاد والتقنيات الأخرى التي تبدأ من خلال استراتيجية قوية وفهم عميق للجمهور المستهدف.",
        "url":"/teams/advertising"
      },
      "4":{
        "title":"تصميم المنتجات",
        "desc":"ابدأ في هندسة مواصفات المنتج بداية من مرحلة النمذجة حتى تنفيذ المواد والنموذج الأولي.",
        "url":"/teams/product-design"
      },
      "5":{
        "title":"تصميم الخطوط",
        "desc":"يمكنك دراسة مجموعة متنوعة من الخطوط بلغات مختلفة للتوصل إلى خطوط مخصصة فريدة من نوعها قابلة للقراءة.",
        "url":"/teams/type-design"
      },
      "6":{
        "title":"التصميم التفاعلي",
        "desc":"تستطيع إنشاء واجهات واضحة وأنظمة تصميم من خلال اتباع استراتيجية بصرية تتوائم مع الجهود مع كل من فرق الأعمال التجارية والعلامات التجارية.",
        "url":"/teams/interaction"
      },
      "7":{
        "title":"البرمجة",
        "desc":"تستطيع اللعب باستخدام الأكواد لإنشاء مواقع الويب والبرامج وتطبيقات الجوال باستخدام أحدث التقنيات. يعمل فريق التطوير بالتوافق مع التصميم والأعمال التجارية  لابتكار المميزات التي تدعم الفكرة العامة.",
        "url":"/teams/development"
      },
      "8":{
        "title":"التكنولوجيا",
        "desc":"احصل على أقصى استفادة من الأجهزة والبرامج لإنشاء حلول مدعومة باحتياجات العمل ومتطلبات العملاء مدعومة بالتكنولوجيا.",
        "url":"/teams/technology"
      }
    },

    "cta":"تعرف على الفرص <br> المتاحة"
  }
}
</i18n>
